import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["onChange", "onChangeMeta", "onFocus", "onBlur", "size", "error", "value", "readOnly", "disabled", "virtualization", "virtualizationThreshold", "VirtualizedMenuList", "components", "creatable", "className", "dataTestId"],
  _excluded2 = ["value", "options"],
  _excluded3 = ["value", "options", "maximum", "isOptionDisabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import clsx from 'clsx';
import Select, { createFilter } from 'react-select';
import { useTranslation } from 'react-i18next';
import { FormSize } from "../../../../view-model";
import { useFormCommonProps } from "../../../context/form-common";
import { nsform } from "../../../../i18n/namespaces";
import { defaultVirtualization, defaultVirtualizationThreshold, useIsVirtualized, VirtualizedMenuList as VirtualizedMenuListComponent } from "../virtualized";
import { useOptionsMap } from "../utils";
import CreatableSelect from 'react-select/creatable';
import "./input-select.style.scss";
const InputSelectRaw = /*#__PURE__*/React.forwardRef((props, ref) => {
  const _useFormCommonProps = useFormCommonProps(props),
    {
      onChange,
      onChangeMeta,
      onFocus,
      onBlur,
      size,
      error,
      value,
      readOnly,
      disabled,
      virtualization = defaultVirtualization,
      virtualizationThreshold = defaultVirtualizationThreshold,
      VirtualizedMenuList = VirtualizedMenuListComponent,
      components,
      creatable = false,
      className,
      dataTestId
    } = _useFormCommonProps,
    rest = _objectWithoutProperties(_useFormCommonProps, _excluded);
  const {
    t
  } = useTranslation(nsform.common);
  const isVirtualized = useIsVirtualized(virtualization, virtualizationThreshold, props.options);
  const SelectComponent = creatable ? CreatableSelect : Select;
  return /*#__PURE__*/React.createElement(SelectComponent, _extends({
    value: value,
    onChange: (selected, action) => {
      onChange && onChange(selected);
      onChangeMeta && onChangeMeta(selected, action);
    },
    formatCreateLabel: inputValue => t('input.select.createOption', {
      value: inputValue
    }),
    onFocus: onFocus,
    onBlur: onBlur,
    menuShouldScrollIntoView: false,
    captureMenuScroll: false,
    menuPlacement: "auto"
    // NOTE filterOption this way generates bugs in InputAsyncSelect
    ,
    filterOption: createFilter({
      ignoreAccents: false
    }),
    isDisabled: disabled || readOnly,
    placeholder: t('input.select.placeholder'),
    noOptionsMessage: ({
      inputValue
    }) => t('input.select.noOptions', {
      value: inputValue
    }),
    "data-test-id": dataTestId,
    isClearable: true,
    isSearchable: true
  }, rest, {
    components: _objectSpread(_objectSpread(_objectSpread({}, components), isVirtualized ? {
      MenuList: VirtualizedMenuList
    } : {}), {}, {
      DropdownIndicator: () => /*#__PURE__*/React.createElement("span", {
        className: "mdi mdi-menu-swap font-size-20 text-primary"
      })
    }),
    ref: ref,
    className: clsx('input-select', className, {
      'input-select-sm': size === FormSize.SM,
      'input-select-lg': size === FormSize.LG,
      'input-select-xl': size === FormSize.XL,
      'input-select-multi': props.isMulti,
      'input-select-has-value': Array.isArray(value) ? value.length : Boolean(value),
      'input-select-error': error
    }),
    classNamePrefix: "input-select"
  }));
});
export const InputSelect = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      value: valueProp,
      options
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  const optionsMap = useOptionsMap(options);
  const value = React.useMemo(() => {
    if (valueProp) {
      if (valueProp.label) return valueProp;
      const option = optionsMap[valueProp.value];
      return option !== null && option !== void 0 ? option : null;
    }
    return null;
  }, [valueProp, optionsMap]);
  return /*#__PURE__*/React.createElement(InputSelectRaw, _extends({}, rest, {
    value: value,
    options: options,
    isMulti: false,
    ref: ref
  }));
});
export const InputMultiSelect = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      value: valueProp,
      options,
      maximum,
      isOptionDisabled
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  const optionsMap = useOptionsMap(options);
  const value = React.useMemo(() => {
    var _valueProp$reduce;
    return (_valueProp$reduce = valueProp === null || valueProp === void 0 ? void 0 : valueProp.reduce((current, item) => {
      const option = optionsMap[item.value];
      if (option) current.push(option);
      return current;
    }, [])) !== null && _valueProp$reduce !== void 0 ? _valueProp$reduce : [];
  }, [valueProp, optionsMap]);
  return /*#__PURE__*/React.createElement(InputSelectRaw, _extends({}, rest, {
    value: value,
    options: options,
    isMulti: true,
    ref: ref,
    isOptionDisabled: (opt, opts) => {
      const disabled = isOptionDisabled ? isOptionDisabled(opt, opts) : false;
      return maximum !== undefined && value ? value.length >= maximum || disabled : disabled;
    }
  }));
});